import { Component, OnInit, ViewChild } from '@angular/core';
import { ListPromocodesComponent } from './originality-sections/list-promocodes/list-promocodes.component';

@Component({
  selector: 'app-originality',
  templateUrl: './originality.component.html',
  styleUrls: ['./originality.component.scss'],
})
export class OriginalityComponent implements OnInit {

  menuItemsEnum = {
    list: 'list',
    generatePromoCodes: 'cash',
    discountSchools: 'public',
    discountUsers: 'private',
    listPromocodes: 'all',
    sendMail: 'sendMail',
  };

  items = [
    {
      title: 'listPromocodes',
      icon: 'fa-settings',
      href: this.menuItemsEnum.listPromocodes,
    },
    {
      title: 'generatePromoCodes',
      icon: 'fa-settings',
      href: this.menuItemsEnum.generatePromoCodes,
    },
    {
      title: 'discountSchools',
      icon: 'fa-settings',
      href: this.menuItemsEnum.discountSchools,
    },
    {
      title: 'discountUsers',
      icon: 'fa-settings',
      href: this.menuItemsEnum.discountUsers,
    },
    {
      title: 'Stav objednávky',
      icon: 'fa-settings',
      href: this.menuItemsEnum.list,
    },
    {
      title: 'sendMail',
      icon: 'fa-settings',
      href: this.menuItemsEnum.sendMail,
    },
  ];

  activeItem = this.items[0].href;

  @ViewChild(ListPromocodesComponent, { static: false }) listPromocodesComponent: ListPromocodesComponent;

  constructor() {
  }

  ngOnInit() {

    if (window.location.hash) {
      this.navigateByHash(window.location.hash);
    } else {
      this.onChangeTab(this.menuItemsEnum.list);
    }

  }

  forceRefreshData() {
    if (this.listPromocodesComponent) {
      this.listPromocodesComponent.submitFilter();
    }
  }

  navigateByHash(hash) {
    const i = this.items.find(it => it.href === hash.split('#')[2]);

    if (i) {
      this.activeItem = i.href;
    }
  }

  onChangeTab(item: string) {
    this.activeItem = item;
    location.hash = `/originality#${item}`;
  }

}
